export enum EventsTypes { // Obsoleted. Use 'EventTypes' enum instead when new calls will be implemented
  LifestylePrograms = 'Lifestyle Programs',
  Notice = 'Notice',
  PremiumServices = 'Premium Services',
  ConciergeRequest = 'conciergeRequest',
  FamilyVisit = 'familyVisit',
  Medical = 'medical',
  Concierge = 'concierge',
  ScheduledCall = 'scheduledCall',
  RealtimeCall = 'realtimeCall',
  Meal = 'Meal',
}

export enum EventTypes {
  LifestylePrograms = "Lifestyle Programs",
  Notice = "Notice",
  PremiumServices = "Premium Services",
  ConciergeRequest = "conciergeRequest",
  FamilyVisit = "familyVisit",
  Medical = "medical",
  Concierge = "concierge",
  Meal = 'Meal'
}